


const impactBatter = {
    1: { s1: 0, s2: 1, s3: 0, s4: 0, s5: 0, s6: 0 },
    2: { s1: 0, s2: 1, s3: 1, s4: 0, s5: 0, s6: 0 },
    3: { s1: 1, s2: 1, s3: 1, s4: 0, s5: 0, s6: 0 },
    4: { s1: 1, s2: 2, s3: 1, s4: 1, s5: 0, s6: 0 },
    5: { s1: 1, s2: 2, s3: 2, s4: 1, s5: 1, s6: 0 },
    6: { s1: 2, s2: 2, s3: 2, s4: 1, s5: 1, s6: 1 },
    7: { s1: 2, s2: 3, s3: 2, s4: 1, s5: 1, s6: 2 },
    8: { s1: 2, s2: 3, s3: 3, s4: 2, s5: 1, s6: 2 },
    9: { s1: 3, s2: 3, s3: 3, s4: 2, s5: 2, s6: 2 },
}

const impactPitcher = {
    1: { s1: 0, s2: 1, s3: 0, s4: 0, s5: 0, s6: 0 },
    2: { s1: 0, s2: 1, s3: 0, s4: 1, s5: 0, s6: 0 },
    3: { s1: 0, s2: 1, s3: 1, s4: 1, s5: 0, s6: 0 },
    4: { s1: 1, s2: 2, s3: 1, s4: 1, s5: 0, s6: 0 },
    5: { s1: 1, s2: 2, s3: 1, s4: 2, s5: 1, s6: 0 },
    6: { s1: 1, s2: 2, s3: 2, s4: 2, s5: 1, s6: 1 },
    7: { s1: 1, s2: 3, s3: 2, s4: 2, s5: 1, s6: 2 },
    8: { s1: 2, s2: 3, s3: 2, s4: 3, s5: 1, s6: 2 },
    9: { s1: 2, s2: 3, s3: 3, s4: 3, s5: 2, s6: 2 },
}

const signatureBatter = {
    1: { s1: 0, s2: 1, s3: 0, s4: 0, s5: 1, s6: 0 }, 
    2: { s1: 0, s2: 1, s3: 1, s4: 0, s5: 1, s6: 1 }, 
    3: { s1: 1, s2: 1, s3: 1, s4: 1, s5: 1, s6: 1 }, 
    4: { s1: 1, s2: 3, s3: 1, s4: 2, s5: 1, s6: 1 }, 
    5: { s1: 1, s2: 3, s3: 3, s4: 2, s5: 2, s6: 1 }, 
    6: { s1: 3, s2: 3, s3: 3, s4: 2, s5: 2, s6: 2 }, 
    7: { s1: 3, s2: 5, s3: 3, s4: 2, s5: 2, s6: 4 }, 
    8: { s1: 3, s2: 5, s3: 5, s4: 4, s5: 2, s6: 4 }, 
    9: { s1: 5, s2: 5, s3: 5, s4: 4, s5: 4, s6: 4 },
};

const signaturePitcher = {
    1: { s1: 0, s2: 1, s3: 0, s4: 0, s5: 1, s6: 0 },
    2: { s1: 0, s2: 1, s3: 0, s4: 1, s5: 1, s6: 1 },
    3: { s1: 1, s2: 1, s3: 1, s4: 1, s5: 1, s6: 1 },
    4: { s1: 2, s2: 3, s3: 1, s4: 1, s5: 1, s6: 1 },
    5: { s1: 2, s2: 3, s3: 1, s4: 3, s5: 2, s6: 1 },
    6: { s1: 2, s2: 3, s3: 3, s4: 3, s5: 2, s6: 2 },
    7: { s1: 2, s2: 5, s3: 3, s4: 3, s5: 2, s6: 4 },
    8: { s1: 4, s2: 5, s3: 3, s4: 5, s5: 2, s6: 4 },
    9: { s1: 4, s2: 5, s3: 5, s4: 5, s5: 4, s6: 4 },
};

const internationalBatter = {
    1: { s1: 0, s2: 1, s3: 0, s4: 0, s5: 1, s6: 0 },
    2: { s1: 0, s2: 1, s3: 1, s4: 0, s5: 1, s6: 1 },
    3: { s1: 1, s2: 1, s3: 1, s4: 1, s5: 1, s6: 1 },
    4: { s1: 1, s2: 2, s3: 1, s4: 2, s5: 1, s6: 1 },
    5: { s1: 1, s2: 2, s3: 2, s4: 2, s5: 2, s6: 1 },
    6: { s1: 2, s2: 2, s3: 2, s4: 2, s5: 2, s6: 2 },
    7: { s1: 2, s2: 4, s3: 2, s4: 2, s5: 2, s6: 4 },
    8: { s1: 2, s2: 4, s3: 4, s4: 4, s5: 2, s6: 4 },
    9: { s1: 4, s2: 4, s3: 4, s4: 4, s5: 4, s6: 4 },
}

const internationalPitcher = {
    1: { s1: 0, s2: 1, s3: 0, s4: 0, s5: 1, s6: 0 },
    2: { s1: 0, s2: 1, s3: 0, s4: 1, s5: 1, s6: 1 },
    3: { s1: 1, s2: 1, s3: 1, s4: 1, s5: 1, s6: 1 },
    4: { s1: 2, s2: 2, s3: 1, s4: 1, s5: 1, s6: 1 },
    5: { s1: 2, s2: 2, s3: 1, s4: 2, s5: 2, s6: 1 },
    6: { s1: 2, s2: 2, s3: 2, s4: 2, s5: 2, s6: 2 },
    7: { s1: 2, s2: 4, s3: 2, s4: 2, s5: 2, s6: 4 },
    8: { s1: 4, s2: 4, s3: 2, s4: 4, s5: 2, s6: 4 },
    9: { s1: 4, s2: 4, s3: 4, s4: 4, s5: 4, s6: 4 },
};

const goldenGloveBatter = {
    1: { s1: 0, s2: 2, s3: 0, s4: 0, s5: 2, s6: 0 },
    2: { s1: 0, s2: 2, s3: 2, s4: 0, s5: 2, s6: 2 },
    3: { s1: 2, s2: 2, s3: 2, s4: 2, s5: 2, s6: 2 },
    4: { s1: 2, s2: 4, s3: 2, s4: 4, s5: 2, s6: 2 },
    5: { s1: 2, s2: 4, s3: 4, s4: 4, s5: 4, s6: 2 },
    6: { s1: 4, s2: 4, s3: 4, s4: 4, s5: 4, s6: 4 },
    7: { s1: 4, s2: 6, s3: 4, s4: 4, s5: 4, s6: 6 },
    8: { s1: 4, s2: 6, s3: 6, s4: 6, s5: 4, s6: 6 },
    9: { s1: 6, s2: 6, s3: 6, s4: 6, s5: 6, s6: 6 },
}

const goldenGlovePitcher = {
    1: { s1: 0, s2: 2, s3: 0, s4: 0, s5: 2, s6: 0 },
    2: { s1: 0, s2: 2, s3: 0, s4: 2, s5: 2, s6: 2 },
    3: { s1: 2, s2: 2, s3: 2, s4: 2, s5: 2, s6: 2 },
    4: { s1: 4, s2: 4, s3: 2, s4: 2, s5: 2, s6: 2 },
    5: { s1: 4, s2: 4, s3: 2, s4: 4, s5: 4, s6: 2 },
    6: { s1: 4, s2: 4, s3: 4, s4: 4, s5: 4, s6: 4 },
    7: { s1: 4, s2: 6, s3: 4, s4: 4, s5: 4, s6: 6 },
    8: { s1: 6, s2: 6, s3: 4, s4: 6, s5: 4, s6: 6 },
    9: { s1: 6, s2: 6, s3: 6, s4: 6, s5: 6, s6: 6 },
};

const level0 = { s1: 0, s2: 0, s3: 0, s4: 0, s5: 0, s6: 0 };

export function calculateAwakenStates(player) {

    const awakenLevel = player.isAwaken ? player.level : 0;

    if(awakenLevel === 0) {
        return level0;
    } else if(player.type === '임팩트') {
        return player.isPitcher ? impactPitcher[awakenLevel] : impactBatter[awakenLevel];
    } else if(player.type === '시그니쳐') {
        return player.isPitcher ? signaturePitcher[awakenLevel] : signatureBatter[awakenLevel];
    } else if(player.type === '국가대표') {
        return player.isPitcher ? internationalPitcher[awakenLevel] : internationalBatter[awakenLevel];
    } else if(player.type === '골든글러브') {
        return player.isPitcher ? goldenGlovePitcher[awakenLevel] : goldenGloveBatter[awakenLevel];
    } else {
        return level0;
    }

}

// 파워, 정확, 선구, 인내, 주루, 수비

// 구속, 변화, 구위, 제구, 지구력 ,수비